/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_Essential_DescInputs */

const en_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session cookies, authentication, preferences`)
};

const de_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzungs-Cookies, Authentifizierung, Einstellungen`)
};

const fr_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies de session, authentification, preferences`)
};

const es_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies de sesion, autenticacion, preferencias`)
};

const it_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie di sessione, autenticazione, preferenze`)
};

const nl_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessiecookies, authenticatie, voorkeuren`)
};

const pl_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciasteczka sesji, uwierzytelnianie, preferencje`)
};

const fi_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istuntoevästeet, todennus, asetukset`)
};

const da_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessionscookies, godkendelse, praeferencer`)
};

const sv_cookie_consent_essential_desc = /** @type {(inputs: Cookie_Consent_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessionscookies, autentisering, installningar`)
};

/**
* | output |
* | --- |
* | "Session cookies, authentication, preferences" |
*
* @param {Cookie_Consent_Essential_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_essential_desc = /** @type {((inputs?: Cookie_Consent_Essential_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_Essential_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_essential_desc(inputs)
	if (locale === "fr") return fr_cookie_consent_essential_desc(inputs)
	if (locale === "es") return es_cookie_consent_essential_desc(inputs)
	if (locale === "it") return it_cookie_consent_essential_desc(inputs)
	if (locale === "nl") return nl_cookie_consent_essential_desc(inputs)
	if (locale === "pl") return pl_cookie_consent_essential_desc(inputs)
	if (locale === "fi") return fi_cookie_consent_essential_desc(inputs)
	if (locale === "da") return da_cookie_consent_essential_desc(inputs)
	if (locale === "sv") return sv_cookie_consent_essential_desc(inputs)
	return en_cookie_consent_essential_desc(inputs)
});